export default "__VITE_ASSET__D0A518y9__"